import styled from 'styled-components';

export const MessageBubbleWrapper = styled.div<{ isUser?: boolean }>`
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  scroll-margin-top: 16px;
  flex-direction: ${(props) => (props.isUser ? 'row-reverse' : 'row')};
`;

export const Bubble = styled.div<{ isUser?: boolean }>`
  background: ${(props) => (props.isUser ? '#2D2D2E' : '#F0F0F0')};
  color: ${(props) => (props.isUser ? '#F2F2F7' : '#000000')};
  ${(props) =>
    props.isUser
      ? `border-top-left-radius: 12px;
border-top-right-radius: 12px;
border-bottom-left-radius: 12px;`
      : `border-top-left-radius: 12px;
border-top-right-radius: 12px;
border-bottom-right-radius: 12px;`};

  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;

  padding: 8px 12px;
  max-width: 70%;
  word-wrap: break-word;

  p {
    font-size: 14px;
    margin: 0;
  }
  .markdown h1,
  .markdown h2,
  .markdown h3 {
    margin-top: 10px;
    margin-bottom: 8px;
  }

  .markdown h1 {
    font-size: 16px;
  }

  .markdown h2 {
    font-size: 16px;
  }

  .markdown h3 {
    font-size: 15px;
  }

  .markdown ul,
  .markdown ol {
    padding-left: 20px;
    margin: 8px 0;
  }

  .markdown p {
    margin: 0;
    font-size: 14px;
  }

  .markdown blockquote {
    margin: 4px 0;
    font-family: inherit;
    max-width: unset;
    font-size: 14px;
    text-align: left;
  }

  .markdown blockquote:before,
  .markdown blockquote:after {
    content: '';
  }

  .markdown ul > li {
    list-style: disc;
    font-size: 14px;
  }

  .markdown code {
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
  }

  .markdown a {
    color: #000000;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: unset;
    text-decoration-skip-ink: auto;
  }
`;
